export default [
  {
    path: '/banco',
    name: 'Banco',
    component: () => import('@/views/cadastros/gerais/banco/list/Index.vue'),
    meta: {
      pageTitle: 'Banco',
      resource: 'AdminHanes',
    },
  },
];
